import * as types from "./actionTypes";
import { USER_LOGOUT_REQUEST } from "../Auth/actionTypes";

const loadSettings = () => {
  try {
    const saved = localStorage.getItem("appSettings");
    if (saved) return JSON.parse(saved);
  } catch (_) {}
  return null;
};

const saved = loadSettings();

const initialState = {
  language: saved?.language || "English",
  font: saved?.font || "Roboto",
};

export const settingsReducer = (state = initialState, { type, payload }) => {
  let nextState;

  switch (type) {
    case types.SET_LANGUAGE:
      nextState = { ...state, language: payload };
      break;

    case types.SET_FONT:
      nextState = { ...state, font: payload };
      break;


    case USER_LOGOUT_REQUEST: {
      // Clear persisted settings and cookie so the app resets after logout
      try {
        localStorage.removeItem("appSettings");
        const expired = "expires=Thu, 01 Jan 1970 00:00:00 UTC";
        document.cookie = `googtrans=; path=/; ${expired}`;
        document.cookie = `googtrans=; domain=${window.location.hostname}; path=/; ${expired}`;
      } catch (_) {}
      return { language: "English", font: "Roboto" };
    }


    default:
      return state;
  }

  // Persist to localStorage so settings survive page reloads
  try {
    localStorage.setItem("appSettings", JSON.stringify(nextState));
  } catch (_) {}

  return nextState;
};
